import ReducerUtils from "../../../utils/ReducerUtils"
import Actions from "../../../model/constant/actions"

const Retrieving = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_DISPLAY_CAMPAIGNS] : (state, action)=>action.status
})

export default Retrieving
